'use client';
import useAspidaSWR from '@aspida/swr';
import { apiClient } from '~/lib/apiClient';
import { ApiPaymentMethod } from '~/types/resources/apiPaymentMethod';

type UseGachaPaymentMethods = {
  gachaPaymentMethods?: ApiPaymentMethod[];
};

export const useGachaPaymentMethods = (
  gacha_id: string | null
): UseGachaPaymentMethods => {
  const { data } = useAspidaSWR(
    apiClient.v1.gachas._gachaId(gacha_id as string).payment_methods,
    {
      enabled: gacha_id !== null,
    }
  );

  return {
    gachaPaymentMethods: data,
  };
};
